"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var options = { log: console.log };

exports.default = options;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fix-it/dist/options.js
// module id = 229
// module chunks = 0 1